export const KINDS = {
  warning: 'warning',
  success: 'success',
  critical: 'critical',
  info: 'info',
};

export const CHIPS = {
  outlined: 'outlined',
  plain: 'plain',
};

export const SIZES = {
  small: 'small',
  regular: 'regular',
};

export const REGULAR_CONFIG = {
  width: 75,
  height: 75,
  baseSpanInDegree: 250,
  strokeWidth: 7,
};

export const SMALL_CONFIG = {
  width: 50,
  height: 50,
  baseSpanInDegree: 200,
  strokeWidth: 5,
};

export const CONFIG = {
  [SIZES.small]: SMALL_CONFIG,
  [SIZES.regular]: REGULAR_CONFIG,
};
